import React from 'react';
import { useGlobalization } from '@Translations';

import { WeibullFallbackBanner } from '@Components/deteriorationModel/utils/WeibullFallbackBanner';

/**
 * Informational note above the failure-definition results list.
 *
 * Renders through `WeibullFallbackBanner`'s `info` severity rather than repeating its markup. The
 * two were byte-for-byte identical once I360A-2883 adopted this palette for the informational
 * variant, which left the same three hexes owned in two files — a palette change would have had to
 * be made twice, and the two info banners could drift apart. The component's name is about where it
 * came from rather than what it can say; the shape is a generic severity banner.
 */
export const FdResultsInfoBanner = (): JSX.Element => {
	const { t } = useGlobalization();

	return (
		<WeibullFallbackBanner
			severity="info"
			testId="fd-results-info-banner"
			message={t(
				'Only assets with an installation date can be used for Weibull curve fitting in deterioration models. Assets missing installation date will appear in this list but will be excluded from model calculations.',
			)}
		/>
	);
};
